class LiveEvents {
  constructor() {
    this.ws = null;
    this.handlers = {};
    this.connected = false;
    this.reconnectTimer = null;
    this.heartbeatInterval = null;
    this.token = null;
  }

  connect(token) {
    this.token = token;

    if (this.connected && this.ws) {
      return;
    }

    if (this.ws) {
      return;
    }

    const protocol =
      window.location.protocol === 'https:' ? 'wss' : 'ws';

    const host = window.location.host;

    this.ws = new WebSocket(
      `${protocol}://${host}/ws-live?token=${token}`
    );

    this.ws.onopen = () => {
      console.log('Live events connected');

      this.connected = true;

      clearTimeout(this.reconnectTimer);

      this._startHeartbeat();

      this.emit('connected');
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        // Ignore server pong replies
        if (data.type === 'pong') return;

        // Force logout: clear token so the reconnect handler does nothing
        if (data.type === 'force_logout') {
          this.token = null;
          clearTimeout(this.reconnectTimer);
        }

        if (data.type) {
          this.emit(data.type, data);
        }

        this.emit('message', data);
      } catch (e) {
        console.error('Invalid WS message', e);
      }
    };

    this.ws.onclose = () => {
      console.log('Live events disconnected');

      this.connected = false;
      this.ws = null;

      this._stopHeartbeat();

      this.emit('disconnected');

      clearTimeout(this.reconnectTimer);

      this.reconnectTimer = setTimeout(() => {
        if (this.token) {
          this.connect(this.token);
        }
      }, 3000);
    };

    this.ws.onerror = (e) => {
      console.error('WS error', e);
    };
  }

  // Keep the WebSocket alive when the browser tab is backgrounded.
  // Browsers kill idle WebSockets after ~60s; a ping every 25s prevents that.
  _startHeartbeat() {
    this._stopHeartbeat();
    this.heartbeatInterval = setInterval(() => {
      this.send({ type: 'ping' });
    }, 25000);
  }

  _stopHeartbeat() {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
    }
  }

  disconnect() {
    clearTimeout(this.reconnectTimer);
    this._stopHeartbeat();

    this.connected = false;

    if (this.ws) {
      this.ws.close();
    }

    this.ws = null;
  }

  send(payload) {
    if (!this.ws) return;

    if (this.ws.readyState !== WebSocket.OPEN) {
      return;
    }

    try {
      this.ws.send(JSON.stringify(payload));
    } catch (e) {
      console.error('WS send failed', e);
    }
  }

  on(event, callback) {
    if (!this.handlers[event]) {
      this.handlers[event] = [];
    }

    this.handlers[event].push(callback);
  }

  off(event, callback) {
    if (!this.handlers[event]) return;

    this.handlers[event] =
      this.handlers[event].filter((cb) => cb !== callback);
  }

  emit(event, payload) {
    if (!this.handlers[event]) return;

    this.handlers[event].forEach((cb) => {
      try {
        cb(payload);
      } catch (e) {
        console.error(e);
      }
    });
  }
}

const liveEvents = new LiveEvents();

export default liveEvents;
